
<template>
  <!-- 提货单  (http://10.100.10.114:32229/apigateway2.0/tq-trade-query/doc.html#/default/%E4%BA%A4%E6%94%B6%E7%9B%B8%E5%85%B3%E6%9F%A5%E8%AF%A2/getBillOfLoadingUsingPOST) -->
  <div id="BillOfLoadingDeliveryDialog">
    <el-dialog title="" :visible.sync="dialogVisible" width="968px" :before-close="changeDialogVisible">
      <div id="PDF_TEXT">
        <h1 class="deliverTitle">提货单</h1>
        <div class="tipWrap">
          <div class="leftTi">注：提货单开具日期（含当日）前的仓储费用由卖方交易商承担，次日起仓储费由买方交易商承担。</div>
          <div class="rightTi">仓单编号：<span class="codeNo">{{ BillOfLoadingData.warehouseId }}</span></div>
        </div>
        <div class="deliverinfoWrap">
          <div class="itemWrap"><span class="titles">提货人姓名</span><span class="itemContent">{{ BillOfLoadingData.consigneeName }}</span></div>
          <div class="itemWrap"><span class="titles">提货方式</span><span class="itemContent">自提</span></div>
          <div class="itemWrap"><span class="titles">提货人电话</span><span class="itemContent" style="text-align:left;">{{ BillOfLoadingData.consigneePhone }}</span></div>
          <div class="itemWrap"><span class="titles">提货人编号</span><span class="itemContent">{{ BillOfLoadingData.userCode }}</span></div>
          <div class="itemWrap"><span class="titles">提货密钥</span><span class="itemContent">{{ BillOfLoadingData.deliveryCode }}</span></div>
          <div class="itemWrap"><span class="titles">提货人身份证号</span><span class="itemContent" style="text-align:left;">{{ BillOfLoadingData.certNo }}</span></div>
        </div>
        <div class="deliverinfoWrap">
          <div class="itemWrap"><span class="titles">商品名称</span><span class="itemContent">{{ BillOfLoadingData.commodityName }}</span></div>
          <div class="itemWrap"><span class="titles">商品数量</span><span class="itemContent">{{ BillOfLoadingData.deliveryQuantity }}</span></div>
          <div class="itemWrap"><span class="titles">商品代码</span><span class="itemContent">{{ BillOfLoadingData.commodityCode }}</span></div>
          <div class="itemWrap"><span class="titles">商品总重量</span><span class="itemContent">{{ BillOfLoadingData.deliveryWeight }}</span></div>
          <div class="itemWrap"><span class="titles">提货仓库</span><span class="itemContent">{{ BillOfLoadingData.storageName }}</span></div>
          <div class="itemWrap"><span class="titles">货位号</span><span class="itemContent">&nbsp;</span></div>
          <div class="itemWrap"><span class="titles">提货地址</span><span class="itemContent">{{ BillOfLoadingData.address }}</span></div>
          <div class="itemWrap"></div>
          <div class="itemWrap"><span class="titles">仓库联系人</span><span class="itemContent">{{ BillOfLoadingData.responsibleName }}</span></div>
          <div class="itemWrap"><span class="titles">仓管员电话</span><span class="itemContent">{{ BillOfLoadingData.responsiblePhone }}</span></div>
          <div class="itemWrap"><span class="titles">提货单开具日期</span><span class="itemContent">{{ BillOfLoadingData.createTime | dateFormateDay }}</span></div>
          <div class="itemWrap"><span class="titles">最后提货日</span><span class="itemContent">最后交收日后第三天</span></div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <!-- <el-button class="el-cancel-btn" @click="changeDialogVisible">关闭</el-button> -->
        <el-button type="primary" class="el-confirm-btn" :disabled="isClicked" @click="download">下载</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
/*global http protocol pdfDownload*/
import {
  mapGetters
} from 'vuex'
export default {
  name: 'BillOfLoading',
  props: ['dialogVisible', 'deliveryId'],
  data() {
    return {
      isClicked: false,
      BillOfLoadingData: {
        'address': '',
        'commodityCode': '',
        'commodityName': '',
        'consigneeName': '',
        'consigneePhone': 0,
        'deliveryCode': '',
        'deliveryId': 0,
        'deliveryQuantity': 0,
        'deliveryWeight': 0,
        'firmCode': '',
        'firmName': '',
        'issuingPeriod': 0,
        'marketId': 0,
        'responsiblePhone': 0,
        'storageName': '',
        'userId': 0,
        'userName': '',
        'warehouseId': 0,
        'certNo': ''
      }
    }
  },
  computed: {
    ...mapGetters([
      'sessionInfoGetter',
      'commodityInformationDataGetter'
    ])
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        this.getBillOfLoading()
      }
    }
  },
  mounted() {},
  methods: {
    // 下载为pdf
    download() {
      this.isClicked = true
      const that = this
      setTimeout(() => {
        that.isClicked = false
      }, 3000)
      const tempNode = document.getElementById('PDF_TEXT')
      pdfDownload.downloadPDF(tempNode, `提货单${this.deliveryId}`)
    },
    getBillOfLoading() {
      const that = this
      protocol.param_getBillOfLoading.param.deliveryId = this.deliveryId
      http.postFront(protocol.param_getBillOfLoading).then(response => {
        const { code, value } = response.data
        if (code === 0 || code === '0') {
          that.BillOfLoadingData = value.content[0]
        }
      })
    },
    // 确定平仓
    confirmClose() {
      this.$emit('boolChange')
    },
    // 取消平仓
    changeDialogVisible() {
      this.$emit('boolChange')
    }
  }

}
</script>
<style scoped lang="scss">
  #PDF_TEXT{
    padding:30px 30px 10px;
    .deliverTitle{
      height: 25px;
      font-family: Source Han Sans SC;
      font-weight: bold;
      font-size: 20px;
      color: #333333;
      line-height: 25px;
      text-align: center;
    }
    .tipWrap{
        margin-top:20px;
        font-size: 14px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #606266;
        display: flex;
        justify-content: space-between;
        .leftTi,.rightTi{
          color:#606266;
        }
    }
    .codeNo{
      color: rgba(0, 0, 0, 0.6);
    }
    .deliverinfoWrap{
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-wrap: wrap;
      margin-top: 55px;
      .itemWrap{
        width: 50%;
        margin-bottom: 20px;
        display: flex;
        align-items: center;
      }
    }
      .titles{
        height: 30px;
        line-height: 30px;
        display: inline-block;
        width: 110px;
        font-family: Source Han Sans SC;
        font-weight: 400;
        font-size: 14px;
        color: #333333;
        text-align: right;
        margin-right: 14px
      }
      .itemContent{
        display: inline-block;
        width: 252px;
        height: 30px;
        line-height: 30px;
        text-indent:14px;
        border-radius: 4px;
        border: 1px solid #999999;
        font-family: Source Han Sans SC;
        font-weight: 200;
        font-size: 12px;
        color: #999999;
      }
  }

</style>
<style>
  #BillOfLoadingDeliveryDialog .el-dialog {
    border-radius: 10px;
    padding: 0px 0px 20px;
    background-color:#fff!important;
  }
  #BillOfLoadingDeliveryDialog .el-dialog__body{
    padding:10px 20px 20px;
  }
  #BillOfLoadingDeliveryDialog .el-dialog__footer {
    padding: 40px;
  }
  #BillOfLoadingDeliveryDialog .el-dialog__footer .dialog-footer {
    text-align: center;
  }
  #BillOfLoadingDeliveryDialog .el-dialog__footer .dialog-footer .el-button{
    padding: 10px 25px;
    border-radius: 20px;
    font-family: Source Han Sans SC;
    font-weight: 400;
    font-size: 14px;
    background: #000000;
    border: 1px solid #000000;
    color: #FFFFFF;
  }
  #BillOfLoadingDeliveryDialog .el-dialog__header{
    padding:0 20px;
  }
  #BillOfLoadingDeliveryDialog .el-dialog__headerbtn{
    top: 42px;
    right: 36px;
  }
</style>

